import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import config from "../firebase-config";
firebase.initializeApp(config);
if (window.location.host.includes('localhost')) {
    console.log("Using emulator...");
    firebase.functions().useEmulator("localhost", 5001);
    // firebase.auth().useEmulator('http://localhost:9099/');
}
// auth
export const auth = firebase.auth();
export const googleAuth = new firebase.auth.GoogleAuthProvider();
export const functions = firebase.app().functions("us-west4");
// export const functions = firebase.app().functions();
// firestore
export const db = firebase.firestore();
